import create from 'zustand'

export const useBStore = create((set) => ({
  bears: 0,
  increasePopulation: () => set((state) => ({ bears: state.bears + 1 })),
  removeAllBears: () => set({ bears: 0 }),
}))

export const useStore = create(set => ({
  auth: false,
  org: null,
  load_accounts:true,
  load_items:true,
  load_series:true,
  fy: null,
  senderid: '',
  categories: [],
  groups: [],
  setStates: (text) =>
    set((state) => ({
      states: text
    })),
  setCategories: (text) =>
    set((state) => ({
      categories: text
    })),
  setSenderid: (text) =>
    set((state) => ({
      senderid: text
    })),
  setAuth: (text) =>
    set((state) => ({
      auth: text
    })),
}));